"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryContactInformation = void 0;
/**
 *  Returns the primary email and phone from a collection of contact channels for a member
 *
 * @param contactChannels
 * @returns { email: string, phone: string }
 */
const getPrimaryContactInformation = (contactChannels) => {
    let email = '', phone = '';
    const { emailChannels, phoneChannels } = contactChannels;
    if (emailChannels) {
        for (const emailChannel of emailChannels) {
            if (emailChannel.email.isPrimary) {
                email = emailChannel.email.address;
                break;
            }
        }
    }
    if (phoneChannels) {
        for (const phoneChannel of phoneChannels) {
            if (phoneChannel.phone.isPrimary) {
                phone = phoneChannel.phone.number;
                break;
            }
        }
    }
    return { email, phone };
};
exports.getPrimaryContactInformation = getPrimaryContactInformation;
//# sourceMappingURL=contact-information.js.map